import moment from 'moment';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { commas } from '../../methods/utils/general-utils';

interface IColumnItem {
	data: any;
}

const Style = styled.div`
	background-color: #f8f8f8;
	padding: 20px;
	margin-bottom: 15px;

	& .amount {
		display: flex;
		font-weight: bold;
		font-size: 16px;
		& img {
			margin-right: 7px;
			width: 20px;
			height: 20px;
		}
	}

	& .details {
		border-top: 1px dashed #ccc;
		margin-top: 12px;
		padding: 15px 0;

		& > * {
			display: inline-block;
			min-width: 200px;
			margin-bottom: 7px;
			padding: 5px;
		}

		& .label {
			font-size: 13px;
			color: #808080;
			font-style: italic;
		}
	}
`;

const ColumnFlexible = ({ data }: IColumnItem) => (
	<Style>
		<div>
			<Link
				to={`/core-modules/flexible-savings/single/${data._id}`}
				className="title"
			>
				<div className="amount">
					<img alt="" src={data.currencyId?.iconUrl} />
					<p>
						{commas(data.apy)}{' '}
						{data?.currencyId?.symbol || data?.currencyId?.name}
					</p>
				</div>
			</Link>
		</div>
		<div className="details">
			<div>
				<p>
					<Link title="View Profile" to={`/user-profile/${data.userId?._id}`}>
						<p>@{data.userId?.username}</p>
					</Link>
				</p>
				<p className="label">Customer</p>
			</div>
			<div>
				<Link
					to={`/core-modules/flexible-savings/single/${data._id}`}
					className="title"
				>
					<p>
						{data.dayBalance
							? commas(data.dayBalance)
							: commas(
									Number(data.dayBalance) *
										Number(data.currencyId?.usdValue || 0)
							  )}
					</p>
					<p className="label">Day Balance</p>
				</Link>
			</div>
			<div>
				<p>
					{data.interest
						? commas(data.interest)
						: commas(
								Number(data.dayBalance) * Number(data.currencyId?.usdValue || 0)
						  )}
				</p>
				<p className="label">Interest</p>
			</div>
			<div>
				<p>
					{data.earnDate
						? moment(data.earnDate).format('MMM DD, YY / hh:mm:ss a')
						: '--'}
				</p>
				<p className="label">Earn Date</p>
			</div>
			<div>
				<p>
					{data.createdAt
						? moment(data.createdAt).format('MMM DD, YY / hh:mm:ss a')
						: '--'}
				</p>
				<p className="label">Date Created</p>
			</div>

			<div>
				<p>
					{data.updatedAt
						? moment(data.updatedAt).format('MMM DD, YY / hh:mm:ss a')
						: '--'}
				</p>
				<p className="label">Last Updated</p>
			</div>
		</div>
	</Style>
);

export default ColumnFlexible;
